import { clickAttachmentFile, getGroupMailboxInfo } from 'owa-group-files-hub-adaptors';
import {
    AttachmentFileInformation,
    BaseFileInformation,
    FileType,
    SharePointFileInformation,
} from 'owa-group-files-hub-store';
import clickSharePointFile from './clickSharePointFile';
import { action } from 'satcheljs/lib/legacy';

export default action('clickRecentFileCardAction')(
    (fileInformation: BaseFileInformation, cardIndex: number) => {
        switch (fileInformation.fileType) {
            case FileType.ClassicAttachment:
            case FileType.CloudAttachment:
                const groupMailboxInfo = getGroupMailboxInfo(fileInformation.groupSmtpAddress);
                const attachmentFileInformation = fileInformation as AttachmentFileInformation;
                clickAttachmentFile({
                    attachmentId: {
                        Id: attachmentFileInformation.attachmentId,
                        mailboxInfo: groupMailboxInfo,
                    },
                    conversationId: {
                        Id:
                            attachmentFileInformation.message &&
                            attachmentFileInformation.message.conversationId,
                        mailboxInfo: groupMailboxInfo,
                    },
                    messageItemId: {
                        Id:
                            attachmentFileInformation.message &&
                            attachmentFileInformation.message.itemId,
                        mailboxInfo: groupMailboxInfo,
                    },
                    conversationSubject: attachmentFileInformation.message.subject,
                    cardIndex: cardIndex,
                });
                break;
            case FileType.SharePointFile:
                clickSharePointFile(fileInformation as SharePointFileInformation, cardIndex);
                break;
        }
    }
);
